import { Colors } from "@zapier/design-system";

export const nodeResizerHandleStyle = {
  width: "12px",
  height: "12px",
  border: `2px solid ${Colors.UiPrimaryStronger}`,
  background: Colors.GrayWarm2,
};

export const nodeResizerLineStyle = {
  color: Colors.UiPrimaryStronger,
  border: `1px solid ${Colors.UiPrimaryStronger}`,
};
